import React from "react";
import { useMutation } from "@apollo/client";
import { omit } from "lodash/fp";

import DynamicForm from "~/src/components/dynamic-form";

import { usePartnerOwners } from "~/src/containers/partners/graphql/use-partner-owners";
import { addOwnerOptions } from "~/src/containers/modals/utils.js";
import UPDATE_TARGET_ACCOUNT from "../graphql/update-target-account";

import schema from "./schema";
import validate from "./validate";

const FORM_ID = "edit-account-info";

const UserInfo = ({ account, connection, refetchTargetAccount, isPartner }) => {
  const [updateTargetAccount] = useMutation(UPDATE_TARGET_ACCOUNT);
  const { partnerOwners } = usePartnerOwners();

  const hasPartnerConnection = isPartner && !!connection;
  const updatedSchema = addOwnerOptions(
    partnerOwners,
    schema.filter(
      field =>
        field.name !== "isCandidatePromosEnabled" || hasPartnerConnection
    )
  );

  const initialValues = {
    ...account,
    ...(hasPartnerConnection && {
      isCandidatePromosEnabled: connection.isCandidatePromosEnabled
    }),
    ownerId: account.ownerId !== null ? parseInt(account.ownerId) : null,
    subvenueSelection: account.subvenueSelection
  };

  return (
    <DynamicForm
      form={FORM_ID}
      schema={updatedSchema}
      validate={validate}
      onSubmit={async updatedValues => {
        const { isCandidatePromosEnabled, ...accountValues } = updatedValues;

        const result = await updateTargetAccount({
          variables: {
            ...accountValues,
            ...(hasPartnerConnection &&
              isCandidatePromosEnabled !== connection.isCandidatePromosEnabled && {
                isCandidatePromosEnabled
              }),
            ...(updatedValues?.accountName && {
              tags: updatedValues?.tags
                ? updatedValues?.tags.map(omit(["__typename"]))
                : []
            })
          },
          refetchQueries: ["getProfile"]
        });

        await refetchTargetAccount();
        return result;
      }}
      initialValues={initialValues}
      isPartner={isPartner}
      isScrollable={false}
    />
  );
};

export default UserInfo;
